import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { ApiErrorShape, ApiRequestDescriptor } from './types.js';

export type SharedBaseQueryFn = BaseQueryFn<ApiRequestDescriptor, unknown, ApiErrorShape>;

let baseQueryImpl: SharedBaseQueryFn | null = null;

/**
 * Registers the app-specific `edenBaseQuery` (auth headers, token refresh, storage) that
 * `delegatingBaseQuery` forwards to. Each app (web, mobile) must call this once at boot, before
 * dispatching any `baseApi` endpoint — `packages/shared` cannot own this implementation itself
 * since it is platform-specific and depends on `@metadevprofile/server`'s `App` type.
 */
export const setBaseQueryImpl = (impl: SharedBaseQueryFn): void => {
  baseQueryImpl = impl;
};

export const delegatingBaseQuery: SharedBaseQueryFn = (args, api, extraOptions) => {
  if (!baseQueryImpl) {
    throw new Error(
      '[@metadevprofile/shared] No baseQuery implementation registered. Call setBaseQueryImpl(...) at app boot before dispatching any baseApi endpoint.',
    );
  }
  return baseQueryImpl(args, api, extraOptions);
};
